<template>
    <div class="container">
        <h2 class="unselectable">{{ title }}</h2>
        <div>
            <Card :description="card.description" />
        </div>
        <textarea id="textBox" name="textBox" v-model="comment" placeholder="KIRJOITA TÄHÄN"></textarea>
        <div>
            <button id="backButton" @click="goBack">Takaisin</button>
            <button id="answerButton" @click="saveAnswer">Kirjaa vastauksesi</button>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import Card from './Card.vue';

export default {
    name: 'Answer',
    props: {
        title: String,
        // Card which the answer is for, passed back to parent in saveAnswer function
        card: Object,
    },
    components: {
        Card
    },
    setup(props, {emit}) {

        const comment = ref('');

        const goBack = () => {
            emit("goBack");
        }

        const saveAnswer = () => {
            // Emit card and the given comment to parent component
            emit("answer", props.card, comment.value);
        }

        return { goBack, saveAnswer, comment };
    },
    emits: ['goBack', 'answer'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body, #answerBox {
    margin: 0px;
    padding: 0px;
}

h2 {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: var(--link_color);
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

#textBox {
    font-size: 20px;
    border: 2px solid #000;
    border-radius: 3px;
    margin: 10px 0;
    padding: 10px;
    width: 45%;
    height: 150px;
    resize: none;
}

#backButton {
    display: inline-block;
    position: relative;
}

#answerButton {
    display: inline-block;
    position: relative;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 20px;
    color: rgb(180, 180, 180);
    text-transform: capitalize;
    opacity: 1; /* Firefox */
}

@media only screen and (max-width: 510px) {
    h2, #textBox {
        width: 80%;
    }

    h2 {
        margin: 10px auto;
    }

    #textBox {
        height: 90px;
    }

    button {
        margin-top: 3px;
        margin-bottom: 3px;
    }
}

</style>
